import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AnalyticsConsent, getAnalyticsConsent, setAnalyticsConsent } from '../lib/analytics';

export function AnalyticsConsentControls() {
  const { t } = useTranslation();
  const [consent, setConsent] = useState<AnalyticsConsent | null>(getAnalyticsConsent());
  const [settingsOpen, setSettingsOpen] = useState(false);

  useEffect(() => {
    const handleConsent = (event: Event) => setConsent((event as CustomEvent<AnalyticsConsent>).detail);
    window.addEventListener('doganju:analytics-consent', handleConsent);
    return () => window.removeEventListener('doganju:analytics-consent', handleConsent);
  }, []);

  const choose = (value: AnalyticsConsent) => {
    setAnalyticsConsent(value);
    setConsent(value);
    setSettingsOpen(false);
  };

  if (consent && !settingsOpen) {
    return (
      <button type="button" onClick={() => setSettingsOpen(true)} className="fixed bottom-4 left-4 z-40 rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm shadow dark:border-slate-600 dark:bg-slate-800" aria-label={t('analyticsSettings')}>
        {t('analyticsSettings')}
      </button>
    );
  }

  return (
    <aside className="fixed inset-x-4 bottom-4 z-50 mx-auto max-w-2xl rounded-xl border border-slate-300 bg-white p-4 shadow-xl dark:border-slate-600 dark:bg-slate-800" role="dialog" aria-labelledby="analytics-consent-title">
      <h2 id="analytics-consent-title" className="mb-2 text-lg font-semibold">{t('analyticsConsentTitle')}</h2>
      <p className="mb-4 text-sm text-slate-700 dark:text-slate-200">{t('analyticsConsentDescription')}</p>
      <div className="flex flex-wrap justify-end gap-2">
        <button type="button" onClick={() => choose('rejected')} className="min-h-11 rounded-lg border border-slate-400 px-4 py-2">{t('analyticsReject')}</button>
        <button type="button" onClick={() => choose('accepted')} className="min-h-11 rounded-lg bg-indigo-600 px-4 py-2 text-white">{t('analyticsAccept')}</button>
      </div>
    </aside>
  );
}
